/**
 * postMessage文档：
 * @huangchengwen 定义的规范
 * https://thoughts.teambition.com/workspaces/60deb323537b8400469a0e42/docs/611b592feaa11900017bb013
 */

export function callMethodInsideIframe(iframe: HTMLIFrameElement, msg: any) {
  (iframe.contentWindow as Window).postMessage(msg, '*');
}

export function requestMethodInsideIframe(
  iframe: HTMLIFrameElement,
  msg: any,
  returnMethod: string
) {
  return new Promise((resolve, reject) => {
    let callbackEnd = false;
    let timeout = false;
    function callback(event?: any) {
      if (callbackEnd) {
        // callback执行过一次就不要再次执行了
        return;
      }

      if (timeout) {
        reject('timeout');
        callbackEnd = true;
        window.removeEventListener('message', callback, false);
        return;
      }

      if (event && event.data) {
        const eventData = event.data || {};
        if (eventData.method === returnMethod) {
          resolve(eventData.data);
          callbackEnd = true;
          window.removeEventListener('message', callback, false);
        }
      }
    }

    setTimeout(function () {
      // 120秒后出发超时逻辑
      timeout = true;
      callback();
    }, 120000);

    window.addEventListener('message', callback, false);
    (iframe.contentWindow as Window).postMessage(msg, '*');
  });
}

export function saveIde(iframe: HTMLIFrameElement) {
  return requestMethodInsideIframe(
    iframe,
    {
      method: 'contestideSave',
    },
    'contestideSaveComplete'
  );
}

export function checkIde(iframe: HTMLIFrameElement) {
  return requestMethodInsideIframe(
    iframe,
    {
      method: 'contestideIsChange',
    },
    'contestideChangeStatus'
  );
}

/**
 * 通知ide那边iframe已经关闭
 * 需要暂停运行中的sb3
 *
 * @export
 * @param {HTMLIFrameElement} iframe
 * @return {*}
 */
export function closeIde(iframe: HTMLIFrameElement) {
  return callMethodInsideIframe(iframe, {
    method: 'contestideClose',
  });
}
